import { useAuth as useCentralAuth } from './AuthProvider';

/**
 * Legacy hook wrapper that points to the centralized AuthProvider.
 * This ensures all components use the same session state.
 */
export function useAuth() {
  return useCentralAuth();
}
